import * as React from "react";
import styled from "@emotion/styled";

const Row = styled.div`
  padding-bottom: 0;
  margin: 0 -1rem;
  &.paddingBottom {
    margin-bottom: 108px;
  }
  &::after {
    content: "";
    display: block;
    clear: both;
  }
`;

export interface IProps {
  children: React.ReactNode;
  style?: object;
  className?: string;
}
export default ({ children, className, ...props }: IProps) => <Row {...props}>{children}</Row>;
